import React from 'react'
import '../styles/siteSelector.css'

interface Site {
    id: string
    name: string
}

interface SiteSelectorProps {
    sites: Site[]
    selectedSite: string
    selectedDate: string
    onSiteChange: (siteId: string) => void
    onDateChange: (date: string) => void
    onFilter: () => void
    onRefresh: () => void
    loading: boolean
}

function SiteSelector({
    sites,
    selectedSite,
    selectedDate,
    onSiteChange,
    onDateChange,
    onFilter,
    onRefresh,
    loading
}: SiteSelectorProps) {
    return (
        <div className='site_selector_container'>
            <div className='selector_group'>
                <div className='selector_item'>
                    <label htmlFor='site_select'>Site:</label>
                    <select
                        id='site_select'
                        value={selectedSite}
                        onChange={(e) => onSiteChange(e.target.value)}
                        disabled={loading}
                        className='site_select'
                    >
                        {sites.map((site) => (
                            <option key={site.id} value={site.id}>
                                {site.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className='selector_item'>
                    <label htmlFor='date_select'>Data:</label>
                    <input
                        id='date_select'
                        type='date'
                        value={selectedDate}
                        onChange={(e) => onDateChange(e.target.value)}
                        disabled={loading}
                        className='date_select'
                    />
                </div>

                <button
                    onClick={onFilter}
                    disabled={loading}
                    className='btn_filter'
                    title='Filtrar dados'
                >
                    <span className='material-symbols-outlined'>search</span>
                    Filtrar
                </button>
            </div>
        </div>
    )
}

export default SiteSelector
